// @flow

import controller from './controller'

// Exports
export default controller
